import { generateUUID } from '@thoughtspot/js-util';
import { getItem, setItem } from '@thoughtspot/local-store';
const SESSION_FORCE_FETCH_DURATION = 10 * 1000;
export const SESSION_EXPIRE_DURATION = 30 * 60 * 1000;
export const SESSION_UPDATE_DURATION = 5 * 60 * 1000;
export const tabGUID = generateUUID();
let sessionProps = null;
function createSession(currentTimestamp) {
    sessionProps = {
        startTimestamp: currentTimestamp,
        sessionGUID: generateUUID(),
        lastAccessedTimestamp: currentTimestamp,
        lastUpdateTimestamp: currentTimestamp,
    };
    setItem('sessionProps', sessionProps);
}
async function maintainSession() {
    const currentTimestamp = Date.now();
    if (!sessionProps || shouldRecreateSession(currentTimestamp)) {
        createSession(currentTimestamp);
    }
    if (!sessionProps ||
        (sessionProps.startTimestamp &&
            currentTimestamp <=
                sessionProps.startTimestamp + SESSION_FORCE_FETCH_DURATION)) {
        sessionProps = await getItem('sessionProps');
    }
    sessionProps.lastAccessedTimestamp = currentTimestamp;
    if (currentTimestamp >=
        sessionProps.lastUpdateTimestamp + SESSION_UPDATE_DURATION) {
        sessionProps.lastUpdateTimestamp = currentTimestamp;
        setItem('sessionProps', sessionProps);
    }
}
function shouldRecreateSession(currentTimestamp) {
    return (!sessionProps.sessionGUID ||
        !sessionProps.startTimestamp ||
        !sessionProps.lastUpdateTimestamp ||
        !sessionProps.lastAccessedTimestamp ||
        currentTimestamp >=
            sessionProps.lastAccessedTimestamp + SESSION_EXPIRE_DURATION);
}
export function getEventSession() {
    maintainSession();
    return { ...sessionProps, tabGUID };
}
export function resetEventSessionTest() {
    sessionProps = null;
}
//# sourceMappingURL=event-session-service.js.map